import ChatViewPage from "./ChatViewPage";

export default ChatViewPage;
